export const blockIconsCommonactionsAdsClickNew = (
	<span className='material-symbols-outlined'>ads_click</span>
);
